import { Skeleton, Table } from '@factorialco/deprecated-design-system'

const LoadingSkeleton = () => {
  return (
    <>
      <Table.Cell colSpan={3}>
        <Skeleton height="s16" width="s120" />
      </Table.Cell>
      <Table.Cell colSpan={7}>
        <Skeleton height="s16" width="s360" />
      </Table.Cell>
      <Table.Cell colSpan={2} padding="s1">
        <Skeleton height="s16" width="s96" />
      </Table.Cell>
    </>
  )
}

export default LoadingSkeleton
